import React, {useState} from "react"
import {useQuery} from "react-admin";
import { formatDateAndTimeFromNowWithTooltip } from "../../../helpers/utils";
import {Button, Card, Modal, Spin, Table, Tabs, Typography} from "antd";
import SkeletonTable, {SkeletonTableColumnsType} from "../../Common/SkeletonTable";
import DeclarationDiff from "../../ChangeInstances/DeclarationDiff";

import {getTagForStates} from "@src/components/Common/Tags";

const { Text } = Typography;
const spinnerElement = <Spin size="large" tip="Loading"><Card style={{height: "100px"}}></Card></Spin>


const ChangeInstanceDetailCompact = ({ record, extraProps }: { record: Record<string, any>, extraProps: any }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedLog, setSelectedLog] = useState('');

    const resource = extraProps.resource;

    const { data: historyData, loaded, error, loading } = useQuery({
        type: 'getAction',
        resource: resource,
        payload: { id: record.id, verb: 'history', filter: { }}
    });

    const renderActivity = (reason: string, record: any) => {
        if (reason==="state") {
            if(record.changed_by)
                return <>
                    <Text code>{record.changed_by}</Text>
                    {record.changed_by_team?<>from <Text code>{record.changed_by_team}</Text></>: ""}
                    changed state to {getTagForStates(record.state)} {formatDateAndTimeFromNowWithTooltip(record.modified)}
                </>
            else
                return <>
                    Stated changed to {getTagForStates(record.state)} {formatDateAndTimeFromNowWithTooltip(record.modified)}
                </>
        } else if (reason==="log") {
            if(record.changed_by)
                return <>
                    <Text code>{record.changed_by}</Text>
                    {record.changed_by_team?<>from <Text code>{record.changed_by_team}</Text></>: ""}
                    updated the log {formatDateAndTimeFromNowWithTooltip(record.modified)}
                </>
            else
                return <>
                    Log changed {formatDateAndTimeFromNowWithTooltip(record.modified)}
                </>
        }
        return <>----</>
    }

    const columnsHistory = [
        {
            title: 'Activityً',
            dataIndex: 'reason',
            key: 'reason',
            render: (text: any, record: any) => <>{renderActivity(text, record)}</>,
        },
        {
            title: '',
            dataIndex: 'log',
            key: 'log',
            render: (text: any) => text !== ''?
                <Button shape={"default"} style={{ height: '24px', lineHeight: '24px', marginLeft: '5px' }} onClick={() => {setSelectedLog(text); setIsModalOpen(true)}}>
                    View log
                </Button>: <></>
        },
    ];


    return (
        <Tabs defaultActiveKey="1" type='card' items={[
            {
                key: '1',
                label: 'History',
                children: historyData ? (
                    <>
                        <SkeletonTable columns={columnsHistory as SkeletonTableColumnsType[]}>
                            <Table
                                title={() => 'Activity'}
                                showHeader={false}
                                rowKey="modified"
                                columns={columnsHistory}
                                dataSource={historyData?.results}
                                pagination={false}
                            />
                        </SkeletonTable>
                        <Modal
                            title="Log"
                            open={isModalOpen}
                            onCancel={() => setIsModalOpen(false)}
                            footer={null}
                            closable={true}
                            width={1000}
                        >
                            <p>{selectedLog}</p>
                        </Modal>
                    </>
                ) : spinnerElement,
            },
            {
                key: '2',
                label: 'Diff',
                children: <DeclarationDiff change_instance={record} />,
            },
        ]} />
    );
}

export default ChangeInstanceDetailCompact